export default __webpack_public_path__ + "static/media/img-pdf.c76f3a63.svg";